import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer>
      <div className="footer-content">
        <p>&copy; 2026, Ghanashyam Khanal</p>
      </div>
    </footer>
  );
};

export default Footer;